import { Bus } from '@orion.ui/orion';
import { } from 'vue';

class NavLoaderService {

	static show (message?: string) {
		Bus.emit('navigationLoader:show', message);
	}

	static hide () {
		Bus.emit('navigationLoader:hide');
	}

}

export default function useNavLoaderService () {
	return NavLoaderService;
}
